module.exports = __webpack_public_path__ + "static/img/stay-option-icon-family.560706e9.svg";